function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__filter0_dd)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.924 40.14v9.087l7.907 4.633v-9.147l-7.907-4.574z",
  fill: "url(#mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint0_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.738 40.14v9.087L30.83 53.86v-9.147l7.907-4.574z",
  fill: "url(#mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint1_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.924 40.14l7.907-4.574 7.907 4.573-7.907 4.574-7.907-4.574z",
  fill: "url(#mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint2_linear)"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.315 24.62v1.819l6.438 3.771v-1.866l-6.438-3.723z",
  fill: "url(#mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint3_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M37.24 24.527v1.912l-6.494 3.769-.067-1.991 6.562-3.69z",
  fill: "url(#mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint4_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M24.315 17.963v7.398l6.438 3.772v-7.447l-6.438-3.723z",
  fill: "url(#mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint5_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M37.19 17.963v7.398l-6.438 3.772v-7.447l6.438-3.723z",
  fill: "url(#mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint6_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M24.315 17.963l6.438-3.723 6.437 3.723-6.437 3.723-6.438-3.723z",
  fill: "url(#mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint7_linear)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M24.315 0v25.361l6.438 3.772V3.723L24.315 0z",
  fill: "url(#mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint8_linear)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M37.24 0v25.361l-6.45 3.735-.11-25.406L37.24 0z",
  fill: "url(#mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint9_linear)"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  opacity: 0.5,
  r: 1.653,
  transform: "matrix(.86603 .5 0 1 11.67 52.319)",
  fill: "#7535FD"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  opacity: 0.9,
  r: 1.24,
  transform: "matrix(.86603 .5 0 1 11.67 52.319)",
  fill: "#7535FD"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  r: 0.827,
  transform: "matrix(.86603 .5 0 1 11.671 52.319)",
  fill: "#002978"
});

var _ref13 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__filter1_d)"
}, /*#__PURE__*/React.createElement("circle", {
  opacity: 0.9,
  r: 2.26,
  transform: "matrix(.86603 .5 0 1 26.51 46.877)",
  fill: "#7535FD"
}), /*#__PURE__*/React.createElement("circle", {
  r: 1.198,
  transform: "matrix(.86603 .5 0 1 26.51 46.876)",
  fill: "#002978"
}));

var _ref14 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__filter2_f)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.639 50.212l-.27-2.83h-1.661l-.45 1.528 2.38 1.302z",
  fill: "url(#mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint10_linear)",
  fillOpacity: 0.5
}));

var _ref15 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint11_linear)",
  strokeWidth: 8,
  strokeLinecap: "round",
  strokeLinejoin: "bevel",
  d: "M23.128 45.921l-.788.464"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint12_linear)",
  strokeWidth: 8,
  strokeLinecap: "round",
  strokeLinejoin: "bevel",
  d: "M23.128 45.921l-.788.464"
});

var _ref17 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__filter3_dd)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.93 48.242v9.088l7.907 4.633v-9.147L8.93 48.242z",
  fill: "url(#mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint13_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.744 48.242v9.088l-7.907 4.633v-9.147l7.907-4.574z",
  fill: "url(#mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint14_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.93 48.242l7.907-4.573 7.907 4.573-7.907 4.574-7.907-4.574z",
  fill: "url(#mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint15_linear)"
}));

var _ref18 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__filter4_d)",
  transform: "matrix(.86603 -.5 0 1 20.79 54.95)"
}, /*#__PURE__*/React.createElement("circle", {
  opacity: 0.9,
  r: 2.26,
  fill: "#7535FD"
}), /*#__PURE__*/React.createElement("circle", {
  r: 1.198,
  fill: "#002978"
}));

var _ref19 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__filter5_f)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.6 58.676l.27-2.829h1.661l.45 1.527-2.38 1.302z",
  fill: "url(#mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint16_linear)",
  fillOpacity: 0.5
}));

var _ref20 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint17_linear)",
  strokeWidth: 8,
  strokeLinecap: "round",
  strokeLinejoin: "bevel",
  d: "M22.343 59.009l-.127-.08"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint18_linear)",
  strokeWidth: 8,
  strokeLinecap: "round",
  strokeLinejoin: "bevel",
  d: "M22.343 59.009l-.127-.08"
});

var _ref22 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__filter6_d)",
  transform: "matrix(-.86603 .5 -.86603 -.5 30.804 40.279)"
}, /*#__PURE__*/React.createElement("circle", {
  opacity: 0.9,
  r: 2.26,
  fill: "#7535FD"
}), /*#__PURE__*/React.createElement("circle", {
  r: 1.198,
  fill: "#002978"
}));

var _ref23 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__filter7_f)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.35 39.588l2.565 1.33.851-1.588-1.097-1.152-2.318 1.41z",
  fill: "url(#mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint19_linear)",
  fillOpacity: 0.5
}));

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M30.739 35.286l.034 4.211",
  stroke: "url(#mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint20_linear)",
  strokeWidth: 8,
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M30.739 35.286l.034 4.211",
  stroke: "url(#mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint21_linear)",
  strokeWidth: 8,
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
});

var _ref26 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 1.159,
  ry: 1.163,
  transform: "matrix(-.86603 .5 -.86603 -.5 30.739 35.1)",
  fill: "#002978"
});

var _ref27 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__filter8_dd)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.165 55.992v9.088l7.907 4.633v-9.147l-7.907-4.574z",
  fill: "url(#mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint22_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.98 55.992v9.088l-7.907 4.633v-9.147l7.907-4.574z",
  fill: "url(#mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint23_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.166 55.992l7.907-4.573 7.907 4.573-7.907 4.574-7.907-4.574z",
  fill: "url(#mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint24_linear)"
}));

var _ref28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint0_linear",
  x1: 27.057,
  y1: 42.386,
  x2: 27.057,
  y2: 52.514,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.153,
  stopColor: "#6E36E5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7535FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint1_linear",
  x1: 34.911,
  y1: 42.8,
  x2: 34.911,
  y2: 51.067,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8146FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.979,
  stopColor: "#7B42F4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint2_linear",
  x1: 30.158,
  y1: 36.186,
  x2: 30.778,
  y2: 44.66,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9664FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#874FFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint3_linear",
  x1: 27.086,
  y1: 26.458,
  x2: 26.233,
  y2: 28.03,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.137,
  stopColor: "#6E36E5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.89,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint4_linear",
  x1: 34.406,
  y1: 26.593,
  x2: 35.124,
  y2: 27.94,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6E36E5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.951,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint5_linear",
  x1: 27.681,
  y1: 19.792,
  x2: 27.681,
  y2: 28.037,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.153,
  stopColor: "#6E36E5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7535FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint6_linear",
  x1: 34.074,
  y1: 20.129,
  x2: 34.074,
  y2: 26.859,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8146FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.979,
  stopColor: "#7B42F4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint7_linear",
  x1: 30.204,
  y1: 14.745,
  x2: 30.709,
  y2: 21.643,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9664FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#874FFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint8_linear",
  x1: 29.196,
  y1: 18.824,
  x2: 25.424,
  y2: 0.142,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.137,
  stopColor: "#6E36E5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.908,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint9_linear",
  x1: 32.43,
  y1: 18.464,
  x2: 37.1,
  y2: 1.579,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6E36E5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.951,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint10_linear",
  x1: 26.583,
  y1: 47.383,
  x2: 26.583,
  y2: 50.571,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.324,
  stopColor: "#371A73"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#371A73",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint11_linear",
  x1: 18.168,
  y1: 46.901,
  x2: 19.636,
  y2: 49.84,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#002978"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.468,
  stopColor: "#1AF98C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#002978"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint12_linear",
  x1: 26.75,
  y1: 46.549,
  x2: 22.842,
  y2: 48.787,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#002978"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.418,
  stopColor: "#002978",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint13_linear",
  x1: 13.063,
  y1: 50.489,
  x2: 13.063,
  y2: 60.617,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.153,
  stopColor: "#6E36E5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7535FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint14_linear",
  x1: 20.917,
  y1: 50.903,
  x2: 20.917,
  y2: 59.17,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8146FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.979,
  stopColor: "#7B42F4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint15_linear",
  x1: 16.163,
  y1: 44.289,
  x2: 16.784,
  y2: 52.763,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9664FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#874FFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint16_linear",
  x1: 20.656,
  y1: 55.847,
  x2: 20.656,
  y2: 59.036,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.304,
  stopColor: "#371A73"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.84,
  stopColor: "#371A73",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint17_linear",
  x1: 25.583,
  y1: 63.034,
  x2: 27.501,
  y2: 60.365,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#002978"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.468,
  stopColor: "#1AF98C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#002978"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint18_linear",
  x1: 20.381,
  y1: 54.955,
  x2: 24.721,
  y2: 57.782,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#002978"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.418,
  stopColor: "#002978",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint19_linear",
  x1: 30.329,
  y1: 40.089,
  x2: 27.567,
  y2: 38.495,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.324,
  stopColor: "#371A73"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.732,
  stopColor: "#371A73",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint20_linear",
  x1: 31.321,
  y1: 33.071,
  x2: 30.138,
  y2: 33.052,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#002978"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.468,
  stopColor: "#4F5B72"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#002978"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint21_linear",
  x1: 29.928,
  y1: 40.659,
  x2: 30.037,
  y2: 36.158,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#002978"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.418,
  stopColor: "#002978",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint22_linear",
  x1: 26.299,
  y1: 58.239,
  x2: 26.299,
  y2: 68.367,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.153,
  stopColor: "#6E36E5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7535FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint23_linear",
  x1: 34.153,
  y1: 58.653,
  x2: 34.153,
  y2: 66.92,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8146FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.979,
  stopColor: "#7B42F4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__paint24_linear",
  x1: 29.399,
  y1: 52.039,
  x2: 30.019,
  y2: 60.513,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9664FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#874FFF"
})), /*#__PURE__*/React.createElement("filter", {
  id: "mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__filter0_dd",
  x: 14.924,
  y: 34.566,
  width: 31.814,
  height: 35.294,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.203922 0 0 0 0 0.0823529 0 0 0 0 0.462745 0 0 0 0.3 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.341176 0 0 0 0 0.152941 0 0 0 0 0.741176 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow",
  result: "effect2_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__filter1_d",
  x: 20.553,
  y: 40.349,
  width: 11.915,
  height: 13.055,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.611765 0 0 0 0 0.423529 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__filter2_f",
  x: 24.259,
  y: 46.383,
  width: 4.38,
  height: 4.829,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__filter3_dd",
  x: 0.93,
  y: 42.669,
  width: 31.814,
  height: 35.294,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.203922 0 0 0 0 0.0823529 0 0 0 0 0.462745 0 0 0 0.3 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.341176 0 0 0 0 0.152941 0 0 0 0 0.741176 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow",
  result: "effect2_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__filter4_d",
  x: 14.834,
  y: 48.422,
  width: 11.914,
  height: 13.054,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.611765 0 0 0 0 0.423529 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__filter5_f",
  x: 18.6,
  y: 54.847,
  width: 4.38,
  height: 4.829,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__filter6_d",
  x: 24.036,
  y: 34.681,
  width: 13.536,
  height: 11.196,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.611765 0 0 0 0 0.423529 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__filter7_f",
  x: 26.351,
  y: 37.178,
  width: 5.416,
  height: 4.74,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__mitigate_svg__filter8_dd",
  x: 14.165,
  y: 50.419,
  width: 31.814,
  height: 35.294,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.203922 0 0 0 0 0.0823529 0 0 0 0 0.462745 0 0 0 0.3 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.341176 0 0 0 0 0.152941 0 0 0 0 0.741176 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow",
  result: "effect2_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow",
  result: "shape"
})));

var SvgMitigate = function SvgMitigate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 86,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMitigate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mitigate.ce1478dc.svg";
export { ForwardRef as ReactComponent };